package com.fireavert.devices.data_models.response

import kotlinx.serialization.Serializable

@Serializable
data class DismissAllEventsForUnitReponse(
    val success: Boolean
)
